import { Fragment } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Terminos = () => {
    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        #title-header{
                            background-image: url(/assets/images/2.jpg);
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <main className="main">

                <div id="title-header" class="page-title dark-background" data-aos="fade">
                    <div class="container position-relative">
                        <h1>Términos y condiciones</h1>
                    </div>
                </div>

                {/* Terminos */}
                <section id="terms-of-service" class="terms-of-service section">
                    <div class="container" data-aos="fade-up">
                        <div class="tos-header text-center" data-aos="fade-up">
                            <span class="last-updated">Última actualización: 12-01-2026</span>
                        </div>

                        <div class="tos-content" data-aos="fade-up" data-aos-delay="200">

                            <div id="agreement" class="content-section">
                                <h3>1. Aceptación de los términos</h3>
                                <p>
                                    Al acceder, navegar, registrarse o utilizar el sitio web y los servicios de <strong>Bela María</strong>,
                                    el usuario acepta de forma expresa y voluntaria los presentes Términos y Condiciones, así como las
                                    políticas aplicables.
                                </p>
                                <div class="info-box">
                                    <i class="bi bi-info-circle"></i>
                                    <p>
                                        Si no está de acuerdo con alguno de estos términos, deberá abstenerse de utilizar el sitio y los
                                        servicios ofrecidos.
                                    </p>
                                </div>
                            </div>

                            <div id="service-description" class="content-section">
                                <h3>2. Descripción del servicio</h3>
                                <p>
                                    Bela María es un espacio integral de bienestar, belleza y salud que pone a disposición de sus
                                    usuarios instalaciones, amenidades y acceso a servicios brindados por especialistas independientes.
                                </p>
                                <ul class="list-items">
                                    <li>Instalaciones y espacios de bienestar</li>
                                    <li>Servicios de belleza, salud y cuidado personal</li>
                                    <li>Paquetes y membresías</li>
                                    <li>Amenidades complementarias</li>
                                </ul>
                            </div>

                            <div id="use-of-site" class="content-section">
                                <h3>3. Uso del sitio web</h3>
                                <p>
                                    El usuario se compromete a utilizar el sitio web de manera lícita, respetuosa y conforme a la
                                    legislación vigente, absteniéndose de realizar actos que puedan afectar su funcionamiento o
                                    seguridad.
                                </p>
                                <div class="alert-box">
                                    <i class="bi bi-exclamation-triangle"></i>
                                    <div class="alert-content">
                                        <h5>Uso responsable</h5>
                                        <p>
                                            Cualquier uso indebido del sitio podrá dar lugar a la suspensión o restricción del acceso.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div id="user-accounts" class="content-section">
                                <h3>4. Registro de usuarios</h3>
                                <p>
                                    Para acceder a ciertos servicios, el usuario deberá crear una cuenta proporcionando información
                                    veraz, completa y actualizada. El usuario es responsable de la confidencialidad de sus credenciales.
                                </p>
                            </div>

                            <div id="specialists" class="content-section">
                                <h3>5. Servicios y especialistas</h3>
                                <p>
                                    Los servicios ofrecidos en Bela María pueden ser brindados por especialistas independientes, quienes
                                    son responsables de su práctica profesional, recomendaciones y resultados.
                                </p>
                                <div class="disclaimer-box">
                                    <p>
                                        Bela María no actúa como prestador médico directo ni garantiza resultados específicos derivados
                                        de los servicios contratados.
                                    </p>
                                </div>
                            </div>

                            <div id="appointments" class="content-section">
                                <h3>6. Citas, paquetes y membresías</h3>
                                <p>
                                    Las citas están sujetas a disponibilidad. Los paquetes y membresías son personales y no transferibles,
                                    salvo indicación expresa. Las condiciones de uso y vigencia serán informadas al momento de la
                                    contratación.
                                </p>
                            </div>

                            <div id="cancellations" class="content-section">
                                <h3>7. Cancelaciones y modificaciones</h3>
                                <p>
                                    Las cancelaciones o reprogramaciones deberán realizarse conforme a las políticas vigentes al momento
                                    de la reserva. El incumplimiento podrá implicar la pérdida de beneficios o cargos aplicables.
                                </p>
                            </div>

                            <div id="facilities" class="content-section">
                                <h3>8. Uso de instalaciones y amenidades</h3>
                                <p>
                                    El usuario se compromete a hacer uso adecuado de las instalaciones y amenidades de Bela María,
                                    siguiendo las indicaciones del personal y respetando las normas internas.
                                </p>
                            </div>

                            <div id="liability" class="content-section">
                                <h3>9. Responsabilidad</h3>
                                <p>
                                    Bela María no será responsable por resultados individuales, reacciones adversas no informadas,
                                    objetos personales extraviados o daños derivados del uso indebido de las instalaciones.
                                </p>
                            </div>

                            <div id="intellectual-property" class="content-section">
                                <h3>10. Propiedad intelectual</h3>
                                <p>
                                    Todos los contenidos del sitio web, incluyendo textos, imágenes, logotipos y diseños, son propiedad
                                    de Bela María o cuentan con los derechos correspondientes.
                                </p>
                            </div>

                            <div id="changes" class="content-section">
                                <h3>11. Modificaciones a los términos</h3>
                                <p>
                                    Bela María se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Las
                                    modificaciones entrarán en vigor a partir de su publicación en el sitio web.
                                </p>
                                <div class="notice-box">
                                    <i class="bi bi-bell"></i>
                                    <p>
                                        El uso continuo del sitio implica la aceptación de los términos actualizados.
                                    </p>
                                </div>
                            </div>

                            <div id="governing-law" class="content-section">
                                <h3>12. Legislación aplicable</h3>
                                <p>
                                    Estos Términos y Condiciones se rigen por las leyes aplicables de los Estados Unidos Mexicanos. Cualquier
                                    controversia será resuelta ante los tribunales competentes.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>

            </main>
        </Fragment>
    )
}

export default Terminos;